/*
 *
 * Profile constants
 *
 */

export const SLICE_NAME = 'profile';
